var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-page',{attrs:{"padding":""}},[_c('div',{staticClass:"row q-mb-xs q-col-gutter-md"},[_c('div',{staticClass:"col-12"},[_c('BoxStoreComparison')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }